module.exports = __webpack_public_path__ + "static/img/ico_intelligence@2x.80d296a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talents/ico_intelligence@2x.png
// module id = z7DP
// module chunks = 0